var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"no-margins",attrs:{"fluid":""}},[_c('Sitetour',{attrs:{"open":_vm.openGuide}}),_c('Welcome')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }